import "bootstrap"; // npm i bootstrap
import {swiperIntro, swiperSimpleCarousel} from "./swiper";
/* import "./menu"; */
import "./gsap";
import "./modal-video";
import "./menu";

const input_material_init = () => {
	document.querySelectorAll('input:not([type="checkbox"]), textarea, select').forEach(inputmat => {
		inputmat.addEventListener('input', function(){
			if(inputmat.value !== ''){
				inputmat.classList.add('activated');
        	}
        	else{
            	inputmat.classList.remove('activated');
        	}
		})
	})
}

document.addEventListener("DOMContentLoaded", function () {
	const elementiParallax = document.querySelectorAll(".parallax");
  
	// Procedi solo se ci sono almeno due elementi
	
  
	const observer = new IntersectionObserver((entries) => {
	  let entryAttiva = null;
	  let maxRatio = 0;
  
	  entries.forEach((entry) => {
		if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
		  maxRatio = entry.intersectionRatio;
		  entryAttiva = entry;
		}
	  });
  
	  if (entryAttiva) {
		elementiParallax.forEach(el => el.classList.remove("active"));
		entryAttiva.target.classList.add("active");
	  }
	}, {
	  // rootMargin applica un margine negativo per "anticipare" l'ingresso/uscita
	  rootMargin: "50% 0px 50% 0px", // top, right, bottom, left
	  threshold: Array.from({ length: 11 }, (_, i) => i / 10)
	});
  
	elementiParallax.forEach(el => observer.observe(el));
  });


  function rimuoviMenuOpen() {
	const navbarCollapse = document.querySelector('.navbar-collapse');
	if (navbarCollapse) {
	  const navLinks = navbarCollapse.querySelectorAll('.nav-link');
	  const body = document.body;
  
	  navLinks.forEach(link => {
		link.addEventListener('click', () => {
		  body.classList.remove('menu-open');
		});
	  });
	}
  }
  

window.addEventListener("DOMContentLoaded", () => {
	swiperIntro();
	swiperSimpleCarousel();
	rimuoviMenuOpen();
});

window.addEventListener("resize", () => {
/*   headerPadding(); */
});

window.addEventListener("scroll", () => {
/*   scrollDownUp(); */
});
